export const profile = {
  title: 'Profil beállítások',
  personalInfo: 'Személyes adatok',
  fullName: 'Teljes név',
  email: 'Email cím',
  phone: 'Telefonszám',
  changePassword: 'Jelszó módosítása',
  currentPassword: 'Jelenlegi jelszó',
  newPassword: 'Új jelszó',
  confirmPassword: 'Új jelszó megerősítése',
  updatePassword: 'Jelszó módosítása'
}
